// Production-safe logger — silenced in production builds
const isDev = process.env.NODE_ENV !== "production";

export function logWarn(...args) {
  if (isDev) console.warn(...args);
}

export function logError(...args) {
  if (isDev) console.error(...args);
}
